// VRG-712 — one tracked link's modal (its clicks and what the visitor looked at), opened from
// the Tracked links table AND from Visitor history's Tracked link column. One component, so
// both open the same thing (§36: extracted on the second use).
import { Modal } from '@repo/ui'

import { TrackedLinkDetail } from './TrackedLinkDetail'

export type TrackedLinkModalTarget = {
  id: string
  label: string
  /** "vera.inc/invite/<code> → <destination>" when the caller has it; the code alone otherwise. */
  description?: string
}

export const TrackedLinkModal = ({ link, onClose }: { link: TrackedLinkModalTarget | null; onClose: () => void }) => (
  <Modal title={link ? link.label : ''} open={Boolean(link)} onClose={onClose} description={link?.description} sx={{ width: 760 }}>
    {link && <TrackedLinkDetail id={link.id} />}
  </Modal>
)
